import {REPORT_TEAMS_EXECUTIVE_DIRECTOR} from '/enum/records.enum';

export default {
  reportName: REPORT_TEAMS_EXECUTIVE_DIRECTOR,
};
